export default __webpack_public_path__ + "static/img14-b308b5373b54ba7cf14ec0cfe6189671.png";